enum AgentCreationStep {
  BEHAVIOR = 'behavior',
  KNOWLEDGE = 'knowledge',
  CAPABILITIES = 'capabilities',
  ANALYTICS = 'analytics',
  LINE = 'line',
}

export default AgentCreationStep;
